class ProductTabs extends HTMLElement {
    constructor() {
        super();
        
        // Elementleri Tanımla
        this.tab = this.querySelectorAll('.tab-title');
        this.tabContents = this.querySelector('.tabs-contents');
        this.tabContent = this.querySelectorAll('.tab-content');
        this.link = this.querySelectorAll('.toggleLink');
        this.readMore = this.querySelectorAll('[data-show-more-toogle]');
        this.tabClose = this.querySelectorAll('.pdViewTab-close');
        
        // Ekran görüntüsündeki 'toggle-content' elementlerini seç (Sorunlu kısım)
        this.toggleContents = this.querySelectorAll('.toggle-content');

        this.isVerticalPopup = this.dataset.vertical === 'sidebar';
        this.isVerticalSidebarMobile = this.dataset.verticalMobile === 'sidebar-mobile';

        // --- BAŞLANGIÇ SIFIRLAMA KODU (BURASI YENİ) ---
        // Sayfa yüklendiğinde açık gelen her şeyi kapatır.

        // 1. Masaüstü Tab başlıklarındaki "açık" sınıfını sil
        this.tab.forEach(t => t.classList.remove('is-open'));

        // 2. Ana içerik kapsayıcısındaki "göster" sınıfını sil
        if(this.tabContents) this.tabContents.classList.remove('is-show');

        // 3. Tab içeriklerindeki "aktif" sınıfını sil
        this.tabContent.forEach(c => c.classList.remove('is-active'));
        
        // 4. Mobil başlık linklerindeki "açık" işaretini sil
        this.link.forEach(l => l.classList.remove('is-open'));

        // 5. EN ÖNEMLİSİ: Mobil/Toggle içeriklerini zorla gizle ve sınıflarını temizle
        this.toggleContents.forEach(tc => {
            tc.classList.remove('is-active');
            tc.classList.remove('is-show');
            tc.style.display = 'none'; // CSS ile görünmez yap (block ise none olur)
        });
        // --- SIFIRLAMA SONU ---

        // Event Listener'ları Ekle
        for (let i = 0; i < this.tab.length; i++) {
            this.tab[i].addEventListener(
                'click',
                this.tabActive.bind(this)
            );
        }
            
        for (let i = 0; i < this.link.length; i++) {
            this.link[i].addEventListener(
                'click',
                this.tabToggle.bind(this)
            );
        }

        document.addEventListener('click', e => {
            if (e.target.matches('[data-show-more-toogle]') || e.target.closest('[data-show-more-toogle]')) {
                this.readMoreReadLess(e)
            }
            else if (e.target.matches('.pdViewTab-close') || e.target.closest('.pdViewTab-close')) {
                this.productTabClose(e)

                if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
                    this.handleVerticalPopupClose(e)
                }
            }
        });

        if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
            const overlay = document.querySelector('.background-overlay');
            if(overlay) {
                overlay.addEventListener('click', this.onBackgroundClick.bind(this));
            }
        }

        setTimeout(() => {
            if (window.innerWidth > 550) {
                const $thisContent = document.getElementById('tab-description-mobile');
                if ($thisContent) {
                    const tabHeight = $thisContent.offsetHeight;
                    const showMoreBtn = $thisContent.querySelector('.tab-showMore');
                    if (showMoreBtn) {
                        const maxHeight = parseInt(showMoreBtn.dataset.desMax);
                        if (tabHeight < maxHeight) {
                            showMoreBtn.remove();
                        }
                    }
                }
            }
        })
    }
    
    tabActive(event){
        event.preventDefault();
        event.stopPropagation();

        var $this = event.target,
            id = $this.getAttribute('href').replace('#', ''),
            button_tab = document.querySelector('.an-horizontal-shaking');

        if(!$this.classList.contains('is-open')) {
            this.tab.forEach((element, index) => {
                element.classList.remove('is-open');
            });

            $this.classList.add('is-open');
            if(this.tabContents) this.tabContents.classList.add('is-show');
            button_tab?.classList.add('open-tab-content');

            this.tabContent.forEach((element, index) => {
                if(element.getAttribute('id') == id){
                    element.classList.add('is-active');
                } else {
                    element.classList.remove('is-active');
                }
            });
        }   

        if($this.classList.contains('open-tab-content')) {
            button_tab?.classList.remove('open-tab-content');
        }

        this.checkTabShowMore(id);
    }

    tabToggle(event){
        event.preventDefault();
        event.stopPropagation();
        
        var $this = event.currentTarget,
            $thisContent = $this.parentNode.nextElementSibling;

        if ($this.classList.contains('popup-mobile') && window.innerWidth <= 551) {
            if ($($thisContent).hasClass('is-show')) {
                $($thisContent).removeClass('is-show');
                // jQuery kullanmadan display kontrolü de ekleyelim
                $thisContent.style.display = 'none';
            }
            else {
                $($thisContent).addClass('is-show');
                $thisContent.style.display = 'block';
            }
        }
        else {
            if(window.innerWidth <= 551 && $this.classList.contains('show-mobile')) {
                $this.classList.remove('is-open');
                $this.classList.remove('show-mobile');
                $($thisContent).slideUp('slow');
            }
            else if($this.classList.contains('is-open')){
                $this.classList.remove('is-open');
                if ((this.isVerticalPopup && window.innerWidth > 550) || ($this.matches('.sidebar-mobile') && window.innerWidth <= 550)) {
                    $thisContent.classList.remove('is-show');
                    document.body.classList.remove('tab-popup-show');
                }
                else {
                    $($thisContent).slideUp('slow');
                }
            } else {
                $this.classList.add('is-open');
                if ((this.isVerticalPopup && window.innerWidth > 550) || ($this.classList.contains('sidebar-mobile') && window.innerWidth <= 550)) {
                    document.body.classList.add('tab-popup-sidebar-show');
                    $thisContent.classList.add('is-show');
                    document.body.classList.add('tab-popup-show');
                } else {
                    $($thisContent).slideDown('slow');
                }
            }
        }
    }

    readMoreReadLess(event){
        event.preventDefault();
        event.stopPropagation();

        var $this = event.target || event.target.closest('[data-show-more-toogle]'),
            id = $this.getAttribute('href').replace('#', ''),
            textShowMore = $this.getAttribute('data-show-more-text'),
            textShowLess = $this.getAttribute('data-show-less-text'),
            parentContainer = $this.closest('.tab-showMore'),
            desMax = parentContainer ? parentContainer.dataset.desMax : 100;

        if($this.classList.contains('is-less')) {
            if(parentContainer) {
                parentContainer.classList.remove('is-less');
                parentContainer.classList.add('is-show');
            }
            $this.classList.remove('is-less');
            $this.classList.add('is-show');
            $this.innerText = textShowMore;
            const targetEl = document.getElementById(`${id}`);
            if(targetEl) targetEl.style.maxHeight = `${desMax}px`;
            
            if(this.tabContents) {
                this.tabContents.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
            }
        } else {
            if(parentContainer) {
                parentContainer.classList.remove('is-show');
                parentContainer.classList.add('is-less');
            }
            $this.classList.remove('is-show');
            $this.classList.add('is-less');
            $this.innerText = textShowLess;
            const targetEl = document.getElementById(`${id}`);
            if(targetEl) targetEl.style.maxHeight = 'unset';
        }
    }

    productTabClose(event) {
        event.preventDefault();
        event.stopPropagation();

        if(this.tabContents) this.tabContents.classList.remove('is-show');

        this.tab.forEach((element, index) => {
            element.classList.remove('is-open');
            document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');
        });

        this.tabContent.forEach((element, index) => {
            element.classList.remove('is-active');
            document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');
        });

        if (window.innerWidth <= 551) {
            const $toggleContent = event.target.closest('.toggle-content');
            if($toggleContent) {
                $toggleContent.classList.remove('is-show');
                $toggleContent.style.display = 'none';
            }
        }
    }

    checkTabShowMore(id) {
        if (window.innerWidth > 550) {
            const $thisContent = document.getElementById(`${id}`);
            if ($thisContent) {
                const tabHeight = $thisContent.offsetHeight;
                const showMoreBtn = $thisContent.querySelector('.tab-showMore');
                if (showMoreBtn) {
                    const maxHeight = parseInt(showMoreBtn.dataset.desMax);
                    if (tabHeight < maxHeight) {
                        showMoreBtn.remove();
                    }
                }
            }
        }
    }

    onBackgroundClick(event) {
        if (event.target.closest('toggle-content.is-show') != null) return 
        document.querySelector('.toggleLink.is-open')?.classList.remove('is-open');
        document.querySelector('.toggle-content.is-show')?.classList.remove('is-show');
        document.body.classList.remove('tab-popup-show');
    }

    handleVerticalPopupClose(event) {
        const icon = event.target 
        const toggleContent = icon.closest('.toggle-content');
        if(toggleContent) toggleContent.classList.remove('is-show');
        
        const tabContent = icon.closest('.tab-content');
        if(tabContent) {
            const link = tabContent.querySelector('.toggleLink');
            if(link) link.classList.remove('is-open');
        }
        document.body.classList.remove('tab-popup-show')
    }
}

customElements.define('product-tab', ProductTabs);